export enum AuthCodeError {
  AUTH_CODE_INCORRECT = '196',
  AUTH_CODE_LIMIT_EXCEEDED = '214',
  ACCOUNT_IS_DISABLED = '215',
  AUTH_CODE_EXPIRED = '216'
}
